import React, { useState } from 'react';
import axios from 'axios';
import { endpoint } from '../../resource/Constant';
import { Backdrop, CircularProgress } from '@mui/material';
import { job_Description_Template } from './job_description_template';

// const getJobDescription = () => {
//     axios.post(`${endpoint}/api/aichatbot/jobdescription` , null , {headers:{Authorization : `Bearer ${localStorage.getItem('adminChatauthToken')}`},data:{}})
// }

export default function JobDescription() {
  const [value, setValue] = useState('');
  const [loader, setLoader] = useState(false);
  const [messages, setMessages] = useState([job_Description_Template[0]]);
  const [suggestion, setSuggestion] = useState([]);
  const [openSuggestion, setOpenSuggestion] = useState(true);

  const getJobDescription = () => {
    setValue('');
    setLoader(true);
    axios
      .post(
        `${endpoint}/api/aichatbot/jobdescription`,
        { prompt: value },
        { headers: { Authorization: `Bearer ${localStorage.getItem('adminChatauthToken')}` } }
      )
      .then((res) => {
        if (messages.length === 0) {
          setMessages((prev) => {
            return [res.data];
          });
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const suggestions = () => {
    setLoader(true);
    axios
      .post(
        `${endpoint}/api/aichatbot/suggestions`,
        { prompt: messages[0] },
        { headers: { Authorization: `Bearer ${localStorage.getItem('adminChatauthToken')}` } }
      )
      .then((res) => {
        setSuggestion((prev) => {
          return [...prev, res.data];
        });
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const handleOpenSuggestion = () => {
    setOpenSuggestion((prev) => !prev);

    if (openSuggestion === false) {
      suggestions();
    }
  };

  const getUpdatedMessage = (updatedPrompt) => {
    setValue('');
    setLoader(true);
    axios
      .post(
        `${endpoint}/api/aichatbot/getupdatedMessage`,
        {
          message: messages[0],
          prompt: updatedPrompt
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem('adminChatauthToken')}` } }
      )
      .then((res) => {
        setLoader(false);
        setMessages((prev) => {
          return [res.data];
        });
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const getFinalResult = () => {
    setValue('');
    setLoader(true);
    axios
      .post(
        `${endpoint}/api/aichatbot/getfinalresult`,
        { prompt: messages[0] },
        { headers: { Authorization: `Bearer ${localStorage.getItem('adminChatauthToken')}` } }
      )
      .then((res) => {
        setMessages((prev) => {
          return [res.data];
        });
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const updateMessage = (updatedPrompt) => {
    setLoader(true);
    setMessages((prev) => {
      return [updatedPrompt];
    });
    setLoader(false);
  };

  return (
    <div style={{ height: '130vh' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: ' #1c1c1c' }}>
        {messages.length !== 0 && (
          <div style={{ color: ' #1c1c1c' }}>
            <div style={{ width: '100%', height: '100px' }}>
              {
                <div
                  style={{
                    whiteSpace: 'pre-wrap',
                    wordWrap: 'break-word',
                    margin: '20px auto',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '10px',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
                  }}
                >
                  {messages.map((message, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          margin: '10px 0',
                          padding: '10px',
                          backgroundColor: '#f9f9f9',
                          borderRadius: '8px',
                          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
                        }}
                      >
                        <p style={{ margin: 0, fontSize: '16px', color: '#333' }}>{message}</p>
                      </div>
                    );
                  })}
                </div>
              }
            </div>
          </div>
        )}
        <div style={{ position: 'fixed', bottom: '0px', marginLeft: '450px', width: '800px', height: '50px' }}>
          <input
            style={{ backgroundColor: 'darkgray', width: '400px', color: 'black ' }}
            onChange={(e) => {
              setValue(e.target.value);
            }}
            value={value}
            type="text"
            className="form-control"
            placeholder="Enter the Requirement of Job Description"
            aria-label="Recipient's username"
            aria-describedby="basic-addon2"
          />
        </div>
        <input
          style={{ position: 'fixed', bottom: '0px', marginLeft: '620px', marginBottom: '11px' }}
          onClick={() => {
            getUpdatedMessage(value);
          }}
          className="btn btn-primary"
          type="submit"
          value="Add Requirement"
        ></input>
        <input
          style={{ position: 'fixed', bottom: '0px', marginLeft: '940px', marginBottom: '11px' }}
          onClick={() => {
            getFinalResult();
          }}
          className="btn btn-success"
          type="submit"
          value="Get Final Result"
        ></input>

        {/* {messages.length !== 0 && (
          <div style={{ color: ' #1c1c1c' }}>
            <div style={{ width: '100%', height: '100px' }}>
              {
                <div
                  style={{
                    whiteSpace: 'pre-wrap',
                    wordWrap: 'break-word',
                    margin: '20px auto',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '10px',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
                  }}
                >
                  {messages.map((message, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          margin: '10px 0',
                          padding: '10px',
                          backgroundColor: '#f9f9f9',
                          borderRadius: '8px',
                          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
                        }}
                      >
                        <p style={{ margin: 0, fontSize: '16px', color: '#333' }}>{message}</p>
                      </div>
                    );
                  })}
                </div>
              }
            </div>
          </div>
        )} */}
      </div>

      {/* {messages.length !== 0 && (
        <div style={{ color: ' #1c1c1c' }}>
          <div style={{ width: '100%', height: '100px' }}>
            {
              <div
                style={{
                  whiteSpace: 'pre-wrap',
                  wordWrap: 'break-word',
                  margin: '20px auto',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '10px',
                  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
                }}
              >
                {messages.map((message, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        margin: '10px 0',
                        padding: '10px',
                        backgroundColor: '#f9f9f9',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
                      }}
                    >
                      <p style={{ margin: 0, fontSize: '16px', color: '#333' }}>{message}</p>
                    </div>
                  );
                })}
              </div>
            }
          </div>
        </div>
      )} */}

      {/* {messages.length !== 0 && <div style={{position : 'fixed' , top : '200px' , right : '10px'}}>
            <button onClick={() => {handleOpenSuggestion()}} className='btn btn-dark' >
                Get Suggestions
            </button>
        </div>} */}

      {/* {openSuggestion && <div>
            <div className='scroll' style={{border : '1px solid black', textAlign: 'left' ,marginTop : '10px',  wordWrap: "break-word", position : 'fixed', top : '180px',right : '10px',   width : '400px' , height : '530px' }}>
                {suggestion.map((message, index) => {
                    return (    
                        <ul key={index} className='list-group'>
                            {(message).split('%').map((line , lineIndex) => {
                                return <li onClick={() => {getUpdatedMessage(line)}} key={lineIndex} className='list-group-item'>{line}</li>
                            })}
                        </ul>
                    );
                })}
            </div>
        </div>} */}

      {/* {suggestion.length !== 0 && 
            <div style={{position : 'absolute' , top : '200px', right : '10px', zIndex : '9999'}}>
                <button onClick={handleOpenSuggestion} className="btn btn-dark">
                    See Suggestions
                </button>
            </div>
        }
        {openSuggestion && 
            <div>
                <div style={{ zIndex : '9999', display: 'flex', justifyContent: 'flex-end', padding : '10px'}}>
                    <div style={{width : "100%" , height : "600px"}}>
                        <h3>Suggestions</h3>
                        {suggestion.map((message, index) => {
                            return (
                                <div key={index} style={{ margin: "10px 0", padding: "10px", backgroundColor: "#f9f9f9", borderRadius: "8px", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)" }}>
                                    <p onClick={() => {updateMessage(suggestion[index])}} style={{ margin: 0, fontSize: "16px", color: "#333" }}>{message}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        } */}
      <Backdrop open={loader}>
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#e01cd5" />
              <stop offset="100%" stopColor="#1CB5E0" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size={70} thickness={3} />
      </Backdrop>
    </div>
  );
}
